export type PointerPoint = { x: number; y: number }

export const clamp = (value: number, min: number, max: number): number =>
  Math.min(max, Math.max(min, value))

export const distance = (left: PointerPoint, right: PointerPoint): number =>
  Math.hypot(left.x - right.x, left.y - right.y)

export const midpoint = (left: PointerPoint, right: PointerPoint): PointerPoint => ({
  x: (left.x + right.x) / 2,
  y: (left.y + right.y) / 2,
})

export const resolveIsDarkMode = (): boolean => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false
  const root = document.documentElement
  const body = document.body

  const themeAttr = (root.getAttribute('data-theme') || body.getAttribute('data-theme') || '').trim().toLowerCase()
  if (themeAttr === 'dark') return true
  if (themeAttr === 'light') return false

  if (
    root.classList.contains('dark') ||
    body.classList.contains('dark') ||
    root.classList.contains('theme-dark') ||
    body.classList.contains('theme-dark')
  ) {
    return true
  }
  if (
    root.classList.contains('light') ||
    body.classList.contains('light') ||
    root.classList.contains('theme-light') ||
    body.classList.contains('theme-light')
  ) {
    return false
  }

  return window.matchMedia('(prefers-color-scheme: dark)').matches
}
